export default __webpack_public_path__ + "static/media/vybemedia-with-bg.2d35a8c4.png";